import { render, staticRenderFns } from "./mediaFocus.vue?vue&type=template&id=a8551afc&scoped=true"
import script from "./mediaFocus.vue?vue&type=script&lang=js"
export * from "./mediaFocus.vue?vue&type=script&lang=js"
import style0 from "./mediaFocus.vue?vue&type=style&index=0&id=a8551afc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8551afc",
  null
  
)

export default component.exports